namespace Areas.Contact.Edit {
    "use strict";

    let tabItems = Areas.createTabsWithSameAction("Contact", "Edit",
        ["Profile"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function updateContact() {
        const form = $("#ContactForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Contact/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }


    export function addToManager() {
        const form = $("#ContactForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const contactId: any = form.option("KeyId");

        const data = JSON.stringify(newData)

        if (result.isValid && contactId != null) {
            sendRequest(`/Contact/Profile/AddManagerRecord/`, data, "POST");
        }
    }

    export function updateContactManager() {
        const form = $("#ContactManagerForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Contact/Profile/ManagerPut/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

}